export const OPTIONS = [
  { value: "-created_at", key: "time-newly-listed" },
  { value: "created_at", key: "time-oldest" },
  { value: "display_price", key: "price-low-to-high" },
  { value: "-display_price", key: "price-high-to-low" },
  { value: "-production_year", key: "newest-year" },
  { value: "production_year", key: "oldest-year" }
];
